import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import {
  Icon,
  ModalBasement,
  ModalContainer,
  SafeHtmlPipe,
} from '@millionshow/client-libs';
import { StorageService } from '@millionshow/api-client';
import { rxResource } from '@angular/core/rxjs-interop';
import { catchError, map, of } from 'rxjs';
import { USE_KEY, PRIVACY_KEY, MARKETING_KEY } from '@millionshow/common';
import { NotFoundComponent } from '../../components/not-found/not-found.component';

interface PolicyModalProps {
  type: 'use' | 'privacy' | 'marketing';
}

@Component({
  selector: 'app-policy-modal',
  templateUrl: './policy.modal.html',
  imports: [
    CommonModule,
    ModalContainer,
    Icon,
    SafeHtmlPipe,
    NotFoundComponent,
  ],
})
export class PolicyModal extends ModalBasement<PolicyModalProps> {
  private readonly storageService = inject(StorageService);

  policyType = computed(() => this.props()?.type || 'use');

  policyKey = computed(() => {
    const type = this.policyType();
    switch (type) {
      case 'privacy':
        return PRIVACY_KEY;
      case 'marketing':
        return MARKETING_KEY;
      default:
        return USE_KEY;
    }
  });

  policyTitle = computed(() => {
    const type = this.policyType();
    switch (type) {
      case 'privacy':
        return '개인정보처리방침';
      case 'marketing':
        return '마케팅활용동의';
      default:
        return '이용약관';
    }
  });

  $term = rxResource({
    stream: ({ params }) =>
      this.storageService
        .storageControllerGetTerms({
          key: params.key,
        })
        .pipe(
          map(res => res['text'] || ''),
          catchError(() => of(''))
        ),
    params: () => ({ key: this.policyKey() }),
  });
}
